import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';

import * as GameActions from '../redux/actions/game_actions';
import EnemyBox from './enemy_box';
import PlayerArea from './player_area';
import LetterBox from './letter_box';
import ScoreBox from './score_box';
import VowelBox from './vowel_box';
import {GameStatus} from '../utils/game';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  side: {
    height: '100%',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

/**
 * The game container
 * @return {react} jsx
 */
export default function ContentArea() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.game.status);
  const foe = useSelector((state) => state.game.foe);

  useEffect(() => {
    dispatch(GameActions.newGame());
  }, []);

  const isDialogOpen = status !== GameStatus.PLAY;

  let dialogTitle = '';
  let dialogText = '';
  let buttonText = '';
  if (status === GameStatus.DEFEAT) {
    dialogTitle = 'Defeat';
    dialogText = 'You have lost, sorry.';
    buttonText = 'New Game...';
  } else if (status === GameStatus.VICTORY) {
    dialogTitle = 'Victory!';
    dialogText = 'You have defeated the Alphabet!!';
    buttonText = 'New Game...';
  } else if (status === GameStatus.ADVANCE) {
    dialogTitle = 'Advance';
    dialogText = `${foe} has been defeated.`;
    buttonText = 'Continue...';
  }

  // @TODO This logic should be moved to redux.
  /**
   * Dispatch actions for advancement or a new game.
   */
  function handleNewGame() {
    if (status === GameStatus.ADVANCE) {
      dispatch(GameActions.advanceForSurvive());
    } else {
      dispatch(GameActions.newGame());
    }
  }

  return (
    <Box m={2}>
      <Dialog
        open={isDialogOpen}
        onClose={handleNewGame}
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {dialogText}
          </DialogContentText>
          <Button onClick={handleNewGame} color="primary">
            {buttonText}
          </Button>
        </DialogContent>
      </Dialog>
      <Grid container className={classes.root} spacing={1}>
        <Grid item xs={3}>
          <PlayerArea />
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <VowelBox />
            </Grid>
            <Grid item xs={12}>
              {status !== GameStatus.INIT && <LetterBox />}
            </Grid>
            <Grid item xs={12}>
              <ScoreBox />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <EnemyBox />
        </Grid>
      </Grid>
    </Box>
  );
};
